import {connect} from '../../../app/connect';
import {
  getIssueAttributesDefinitionsTableHighlightedRows,
  getIssueAttributesMappingsMappedEntities,
  getIssueTypesAdminEntitiesMap
} from '../../../app/selectors';
import featureFlags, {FEATURE_FLAGS} from '../../../utils/featureFlags';
import IssueAttributesAdminTable from './IssueAttributesAdminTable';

const mapStateToProps = state => ({
  highlightRowIds: getIssueAttributesDefinitionsTableHighlightedRows(state),
  issueAttributeMappings: getIssueAttributesMappingsMappedEntities(state),
  fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMap(state),
  mapAttributesFromCustomAttributesEnabled: featureFlags.get(FEATURE_FLAGS.MAP_ATTRIBUTES_FROM_CUSTOM_ATTRIBUTES)
});

export default connect(mapStateToProps)(IssueAttributesAdminTable);
